import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreatePackageTemplate } from "../api/queries";
import { PackageTemplateForm } from "../ui/PackageTemplateForm";

export function PackageTemplateCreatePage() {
  const nav = useNavigate({ from: "/app/packages/templates/create" });
  const createTemplate = useCreatePackageTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Template ແພັກເກດ", to: "/app/packages/templates" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງ Package Template
            </h2>
            <p className="text-muted-foreground">
              ສ້າງ template ແພັກເກດໃໝ່ໃນລະບົບ.
            </p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/packages/templates" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <PackageTemplateForm
            onSubmit={async (vals) => {
              try {
                const result = await createTemplate.mutateAsync(vals);
                nav({
                  to: "/app/packages/templates/$id",
                  params: { id: result.id },
                });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createTemplate.isPending}
          />
        </div>
      </Main>
    </>
  );
}
